(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-activity"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.mm-activity');

    roots.forEach(function (root) {
      if (root.dataset.mmReady === 'true') return;
      root.dataset.mmReady = 'true';

      var items = root.querySelectorAll('.mm-activity__item');
      if (!items.length) return;

      try {
        if (sessionStorage.getItem('mmActivityClosed') === '1') return;
      } catch (e) {}

      var index = 0;
      items[0].classList.add('is-current');
      root.hidden = false;

      var wait = parseFloat(root.dataset.interval) * 1000;
      if (isNaN(wait) || wait < 2000) wait = 5000;

      if (items.length > 1) {
        setInterval(function () {
          var current = items[index];
          current.classList.add('is-fading');

          setTimeout(function () {
            current.classList.remove('is-current', 'is-fading');
            index = (index + 1) % items.length;
            items[index].classList.add('is-current');
          }, 350);
        }, wait);
      }

      var close = root.querySelector('.mm-activity__close');
      if (close) {
        close.addEventListener('click', function () {
          root.hidden = true;
          try {
            sessionStorage.setItem('mmActivityClosed', '1');
          } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
